import React, { FC, useMemo } from 'react';

import { PRIMARY_BLUE } from 'constants/colours';

import AIGenerateIcon from '../icons/AIGenerateIcon';
import { Button } from '../buttons';

interface AITriggerModalButtonProps {
  handleClick: () => void;
  label: string;
  // deafult: blue background
  // basic: no outline, no background, text primary color
  variant?: 'default' | 'basic';
}

export const AITriggerModalButton: FC<React.PropsWithChildren<AITriggerModalButtonProps>> = ({
  handleClick,
  label,
  variant = 'default'
}) => {
  const style = useMemo(() => {
    if (variant === 'basic') {
      return {
        borderRadius: '8px',
        width: '100%'
      };
    }

    return {
      background: 'linear-gradient(74.02deg, rgba(240,248,255,1) 14%, rgba(9,135,242,1) 350%)',
      borderRadius: '8px',
      border: `1px solid ${PRIMARY_BLUE}`
    };
  }, [variant]);

  return (
    <Button
      onClick={(): void => {
        handleClick();
      }}
      type="button"
      compact
      style={style}
    >
      <div className="tw-flex tw-flex-row tw-items-center tw-justify-center">
        <div className="tw-mt-0.5">
          <AIGenerateIcon />
        </div>
        <div className="tw-ml-1 tw-mt-[1px] tw-font-poppins tw-text-primary-blue">{label}</div>
      </div>
    </Button>
  );
};
